import { DNode } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, destroy, v, w } from '@dojo/framework/core/vdom';
import { TwoColumnLayout } from '@dojo/widgets/two-column-layout';
import { createNlsMiddleware, lccstate, userstate } from '@holmescorp/lcc-state';

import css from '../css/micro-view.m.css';
import { ViewProperties } from '../interfaces';

export interface MicroViewICache {}

const icache = createICacheMiddleware<MicroViewICache>();

export interface MicroViewProperties extends ViewProperties {}

const factory = create({
	icache,
	theme,
	destroy,
	nls: createNlsMiddleware('ditabook'),
	settings: createNlsMiddleware('settings'),
	resources: createNlsMiddleware('resources'),
	lccstate,
	userstate
}).properties<MicroViewProperties>();

export const MicroView = factory(
	({
		id: instanceId,
		properties,
		middleware: { icache, theme, destroy, nls, settings, resources, lccstate, userstate }
	}): DNode => {
		globalThis.document.getElementById('content-main')?.classList.add('study');
		destroy((): void | undefined => globalThis.document.getElementById('content-main')?.classList.remove('study'));

		// const { switchView, setTitle } = properties();
		const { root, columns, trailingColumn, content, tools } = theme.classes(css);
		const id = 'micro-view';
		const widgetId = `${id}-${instanceId}`;

		const overrides = {
			'@dojo/widgets/two-column-layout': {
				column: [columns],
				small: [trailingColumn]
			}
		};

		return v(
			'div',
			{
				id,
				widgetId,
				key: widgetId,
				xqa: `${id}-widget`,
				classes: [theme.variant(), root]
			},
			[
				w(
					TwoColumnLayout,
					{ key: `two-column-layout`, breakpoint: 1024, classes: overrides, bias: 'leading' },
					[
						{
							leading: v('div', { xqa: `${id}-content`, classes: [content] }),
							trailing: v('div', { xqa: `${id}-tools-sidebar`, classes: [tools] })
						}
					]
				)
			]
		);
	}
);

export default MicroView;
